import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { TextField, useControlledField } from '@frontend/design-system';

interface ProviderFieldsProps {
  firstName?: string;
  lastName?: string;
  setFirstName: (name: string) => void;
  setLastName: (name: string) => void;
}

export const ProviderFields = ({ firstName, lastName, setFirstName, setLastName }: ProviderFieldsProps) => {
  const { t } = useTranslation('schedule-onboarding');

  const firstNameField = useControlledField({
    type: 'text',
    value: firstName,
    onChange: (value) => setFirstName(value),
  });
  const lastNameField = useControlledField({
    type: 'text',
    value: lastName,
    onChange: (value) => setLastName(value),
  });

  return (
    <>
      <TextField
        autoFocus
        name='first-name'
        label={t('First Name')}
        {...firstNameField}
        css={{ backgroundColor: theme.colors.white }}
      />
      <TextField
        name='last-name'
        label={t('Last Name')}
        {...lastNameField}
        css={{ backgroundColor: theme.colors.white }}
      />
    </>
  );
};
